// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui/dist/semantic.min.css
// module id = 243
// module chunks = 1